'use client';

import { type ComponentType } from 'react';
import { useStepsContext, type ComponentName } from '@/providers/pi-multi-step-form/StepsContext';
import WhatHappened from './what-happened';
import WereYouInjured from './were-you-injured';
import TellUsAboutYourself from './tell-us-about-yourself';
import HeresWhatsNext from './heres-whats-next';

const components: Record<ComponentName, ComponentType> = {
  WhatHappened,
  WereYouInjured,
  TellUsAboutYourself,
  HeresWhatsNext,
};

export default function Wrapper() {
  const { step } = useStepsContext();

  const CurrentStep = components[step.component];

  return <CurrentStep />;
}
